import script from "./radio-item.vue?vue&type=script&setup=true&lang=ts"
export * from "./radio-item.vue?vue&type=script&setup=true&lang=ts"

import "./radio-item.vue?vue&type=style&index=0&id=58d01ae9&lang=scss"

const __exports__ = script;

export default __exports__